export type TOfferingPlanningTone = 'success' | 'caution' | 'warning' | 'danger'

/* The levels the attention widget paints: 3 in the danger red, 2 in the dark orange, 1 in the
   light orange. */
const TONE_BY_SEVERITY: Record<number, TOfferingPlanningTone> = {
  3: 'danger',
  2: 'warning',
  1: 'caution',
}

/**
 * How a programme tab is coloured: by the most severe attention status the programme raised, in
 * the colour the attention widget gives that level. With none raised it is green once planning has
 * started and neutral before, as nothing planned is not the same as nothing wrong. A level the
 * widget has no colour for leaves the tab neutral too.
 */
export const getOfferingPlanningTone = (
  maxSeverity: number | undefined,
  isPlanningStarted: boolean
): TOfferingPlanningTone | undefined => {
  if (maxSeverity === undefined) {
    return isPlanningStarted ? 'success' : undefined
  }

  return TONE_BY_SEVERITY[maxSeverity]
}
